import type { GeoCoordinates, GeolocationPort, GeolocationReadOutcome } from '../../domain/ports/GeolocationPort.ts';

export type { GeoCoordinates, GeolocationPort };

function mapGeolocationError(code: number): GeolocationReadOutcome['kind'] {
  if (code === 1) return 'denied';
  if (code === 3) return 'timeout';
  return 'unavailable';
}

export class BrowserGeolocationAdapter implements GeolocationPort {
  readCurrentPositionOutcome(): Promise<GeolocationReadOutcome> {
    if (!globalThis.navigator?.geolocation) return Promise.resolve({ kind: 'unsupported' });
    return new Promise((resolve) => {
      globalThis.navigator.geolocation.getCurrentPosition(
        (pos) =>
          resolve({
            kind: 'ok',
            coords: { lat: pos.coords.latitude, lng: pos.coords.longitude },
          }),
        (err) => {
          const kind = mapGeolocationError(err.code);
          if (kind === 'denied') resolve({ kind: 'denied' });
          else if (kind === 'timeout') resolve({ kind: 'timeout' });
          else resolve({ kind: 'unavailable' });
        },
        { enableHighAccuracy: true, timeout: 12_000, maximumAge: 60_000 },
      );
    });
  }

  async readCurrentPosition(): Promise<GeoCoordinates | null> {
    const outcome = await this.readCurrentPositionOutcome();
    return outcome.kind === 'ok' ? outcome.coords : null;
  }
}
